import Gonggao from "@/pages/gonggao.vue";
import request from "@/request/request.js";

// 公共
const common = {
  rechangePassword(data) {
    return request({
      url: "/admin/auth/reset-password",
      method: "post",
      data: data,
    });
  },
  login(data) {
    return request({
      url: "/admin/auth/login",
      method: "post",
      data,
    });
  },
  getAdminUserInfoByToken(data) {
    return request({
      url: "/admin/auth/info",
      method: "get",
      params: data,
    });
  },
  getList(data) {
    return request({
      url: "/auth/list",
      method: "get",
      params: data,
    });
  },
  setCount(count) {
    return request({
      url: "/api/credit/target?target=" + count,
      method: "PUT",
    });

  },
  gettongji() {
    return request({
      url: "/api/course/enhanced/home-statistics",
      method: "get",
    });
  }
};


const user = {
  getList(data) {
    return request({
      url: "/admin/user/list",
      method: "post",
      data: data,
    });
  },
  create(data) {
    return request({
      url: "/admin/auth/create",
      method: "post",
      data: data,
    });
  },
  upDate(data) {
    return request({
      url: "/admin/user/update",
      method: "post",
      data: data,
    });
  },
  sancufenzu(data){
    return request({
      url: `/api/group/${data.groupoldId}/user/${data.userId}`,
      method: "delete",
      data: data,
    });
  },
   tianjiafenzu(data){
    return request({
      url: `/api/group/${data.groupId}/user/${data.userId}`,
      method: "post",
      data: data,
    });
  },
  gengxin(data){
    return request({
      url: "/admin/user/organization",
      method: "put",
      data: data,
    });
  },
  delete(data) {
    return request({
      url: "/admin/user/delete",
      method: "post",
      data: data,
    });
  },
};

const origin = {
  getList(data) {
    return request({
      url: "/api/group/list",
      method: "get",
      params: data,
    });
  },
  create(data) {
    return request({
      url: "/api/group",
      method: "post",
      data: data,
    });
  },
  upDate(data) {
    return request({
      url: "/api/group/" + data.groupId,
      method: "put",
      data: data,
    });
  },
  delete(groupId) {
    return request({
      url: `/api/group/${groupId}`,
      method: "delete",
    });
  },
};

const zuti = {
  getList(data) {
    return request({
      url: "/admin/course/theme/list",
      method: "POST",
      data: data,
    });
  },
  create(data) {
    return request({
      url: "/admin/course/theme/create",
      method: "post",
      data: data,
    });
  },
  upDate(data) {
    return request({
      url: "/admin/course/theme/update",
      method: "put",
      data: data,
    });
  },
  delete(themeId) {
    return request({
      url: `/admin/course/theme/delete`,
      method: "POST",
      data: {
        themeId
      }
    });
  },
};


const classics = {
  getList(data) {
    return request({
      url: "/admin/course/list",
      method: "post",
      data: data,
    });
  },
  create(data) {
    return request({
      url: "/api/course",
      method: "post",
      data: data,
    });
  },
  upDate(data) {
    return request({
      url: "/api/course/" + data.courseId,
      method: "put",
      data: data,
    });
  },
  delete(courseId) {
    return request({
      url: "/api/course/" + courseId,
      method: "delete",
    });
  },
  getCById(courseId) {
    if(!courseId) return;
    
    return request({
      url: "/api/course/enhanced/children/" + courseId,
      method: "get",
    });
  },
  getqrcodde(courseId) {
    return request({
      url: "/api/course/" + courseId + "/qrcode",
      method: "get",
    });
  },
  getuserlistByid(data) {
    if(!data.courseId) return;
    return request({
      url: "/api/course/enhanced/sub-course-students/" + data.courseId,
      method: "get",
      params: data,
    });
  },
  getclasslistByid(data) {
    return request({
      url: "/api/course/enhanced/user-sub-courses",
      method: "POST",
      data: data,
    });
  },
  remove(id) {
    return request({
      url: "/api/enrollment/admin/remove/" + id,
      method: "delete",
    })
  },
    buqian(data) {
    return request({
      url: "/admin/attendance/supplement" ,
      method: "post",
      data: data,

    })
  },
  baoming(data){
    return request({
      url: "/api/enrollment/admin/create",
      method: "post",
      data: data,
    })
  }
};

const niandu = {
  getInfo(courseId) {
    return request({
      url: "admin/course/children",
      method: "post",
      data: {
        "parentCourseId": courseId   // 父课程ID，必填
      }
    });
  },

}

const gongao={
  getDeatil(){ 
    return request({
      url: "/admin/announcement/detail/" + 1,
      method: "get",
    });
  },
  setGonggao(data){
    return request({
      url: "/admin/announcement/update",
      method: "put",
      data: data,
    });
  }
}

export default {
  common,
  origin,
  user,
  classics,
  zuti,
  niandu,
  Gonggao: gongao,
};
